export async function getRevenueTargetingModels(token) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function getRevenueTargetingModel(token, id) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/?ids=${id}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function createRevenueTargetingModel(
  token,
  accountID,
  name,
  goal
) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: JSON.stringify({
          name: name,
          account: accountID,
          active: false,
          goal,
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function activateRevenueTargetingModel(token, id) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/`,
      {
        method: "PATCH",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: JSON.stringify({
          id: id,
          active: true,
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function deactivateRevenueTargetingModel(token, id) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/`,
      {
        method: "PATCH",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: JSON.stringify({
          id: id,
          active: false,
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function saveRevenueTargetingModel(token, model) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/`,
      {
        method: "PATCH",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: JSON.stringify(model),
      }
    );
    return response;
  } catch (error) {
    return [];
  }
}

export async function updateTrainingDatasets(token, id, trainingDatasets) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/`,
      {
        method: "PATCH",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: JSON.stringify({
          id: id,
          training_datasets: trainingDatasets,
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function updateName(token, id, name) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/revenue-targeting-models/`,
      {
        method: "PATCH",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: JSON.stringify({
          id: id,
          name: name,
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function getAiSignals(token, motivationKeywords) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/ai-signals/`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: JSON.stringify({
          keywords: motivationKeywords
        })
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}
